// extracted by mini-css-extract-plugin
export default {"img":"news_img__ZF1jt","texto":"news_texto__vosaB","containerNews":"news_containerNews__9fttS","titulo":"news_titulo__5MxPp","newsTitle":"news_newsTitle__FhcgL"};